import React, { useEffect, useRef } from "react";
import { Data } from "./Documents";
import { useDispatch, useSelector } from "react-redux";
import { documentsFilesDownloader } from "./helpers/useDownloader";
import {
  clearSubmitResponseErrors,
  selectSubmitResponse,
} from "reducers/submitResponse";
import ToastMessage, { toastConfig } from "helpers/ToastMessage/ToastMessage";
import { toast } from "react-toastify";

type DocumentsDownloadPlaceholderProps = {
  selectedData: Data[];
  onDone(): void;
  additionalData: any;
  nestedListPageUrl?: string;
  parentSelectedIdName?: string;
  fileExtensionColumnName?: string;
  parentSelectedId?: number;
};
const DocumentsDownloadPlaceholder: React.FC<DocumentsDownloadPlaceholderProps> = ({
  selectedData,
  onDone,
  additionalData,
  nestedListPageUrl,
  parentSelectedIdName,
  parentSelectedId,
  fileExtensionColumnName,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      selectedData &&
      Array.isArray(selectedData) &&
      selectedData.length > 0 &&
      typeof selectedData[0] === "object"
    ) {
      const data = selectedData[0];

      let documentName = data.documents__Name ?? "downloaded_file";

      if (
        selectedData.length === 1 &&
        fileExtensionColumnName &&
        selectedData[0] &&
        selectedData[0].hasOwnProperty(fileExtensionColumnName)
      ) {
        documentName +=
          selectedData[0][
            fileExtensionColumnName as keyof typeof selectedData[0]
          ];
      } else {
        documentName = "Downloaded Files.zip";
      }

      documentsFilesDownloader(
        dispatch,
        null,
        documentName,
        additionalData,
        nestedListPageUrl,
        parentSelectedIdName,
        parentSelectedId
      );

      onDone();
    }
  }, [selectedData]);

  const submitResponseErrors = useSelector(selectSubmitResponse)
    .submitResponseErrors;
  const hasMounted = useRef<boolean>(false);

  useEffect(() => {
    if (submitResponseErrors && hasMounted.current) {
      toast(
        <ToastMessage
          toastData={Object.entries(submitResponseErrors).map(
            ([title, text]: [string, any]) => ({
              title,
              text,
            })
          )}
          className="ToastError"
        />,
        {
          ...toastConfig,
        }
      );
    }
    if (!hasMounted.current) {
      dispatch(clearSubmitResponseErrors());
      hasMounted.current = true;
    }
  }, [submitResponseErrors]);

  return <></>;
};

export default DocumentsDownloadPlaceholder;
